<template lang="pug">
  .body.garbage-table.body-flex.bigger-first-col
    .table-choose-panel.toolbar.toolbar_no-padding.toolbar_margin-bottom.body-flex
      .toolbar-table.toolbar__line.toolbar__line_flex-wrap
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )
        .toolbar.toolbar--modal.toolbar_no-padding
          .toolbar__line.line
            .parameters
              e-year-selector(v-if='hasMsnGarbageYear' year="year")
            .actions-panel.view-panel.view-panel_divide
              e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToGarbageTable" label="Добавить" )

      e-table-editable(
        v-if="operationType === 'operation-detail'"
        ref="detail"
        :attributes="garbageDetailAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :prepareRow="prepareRow"
      )

      e-table-editable(
        v-if="fields.is_separate && operationType === 'operation-detail-separate'"
        ref="detailSeparate"
        :attributes="garbageDetailAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :prepareRow="prepareRow"
      )
      div(v-if="operationType !== 'operation-detail-separate' && operationType !== 'operation-detail' ") Таблица раздельных отходов доступна только для объектов с раздельным сбором
</template>

<script>
import { msn, cadastr } from '@/api/api-endpoints'
import { msnOffline } from '@/api/api-offline-endpoints'
import year from '@/utils/year'
import hasMixin from '@/mixins/has-mixin'

export default {
  name: 'garbage-table',
  mixins: [hasMixin],
  props: {
    id: null,
    tabView: null,
    fields: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      operationType: null,
      year: year.getCurrentYear(),
      search: '',
      searchModel: '',
    }
  },
  computed: {
    selectListOptions() {
      let tmp = [
        {
          id: 'operation-detail',
          name: 'Несортированные отходы',
        },
      ]
      if (this.fields.is_separate) {
        tmp.push({
          id: 'operation-detail-separate',
          name: 'Раздельный сбор отходов',
        })
      }
      return tmp
    },
    tableInOnlineMode() {
      return this.$route.params.id
    },
    enableOnAdd() {
      return ['fkkoName']
    },
    garbageDetailAttr() {
      return {
        fkkoName: {
          label: 'Наименование отхода',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: 'Выберите отход чтобы появился ФККО',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$',
        },
        danger: {
          label: 'Класс опасности',
          placeholder: 'цифра',
          required: true,
          disabled: true,
          validationRulePattern: '^([1-5])$',
        },
        composition: {
          label: 'Компонентный состав',
          validationRulePattern: '(\\.*)',
          disabled: true,
        },
      }
    },
    garbageDataUrl() {
      if (this.id) {
        let routeQuery = {
          query: {
            sourceId: this.id,
            type: this.operationType,
          },
        }
        if (!this.hasMsnGarbageYear) {
          routeQuery.query['per-page'] = -1
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }

        return msn.garbageOperation(routeQuery)
      }
      // if new record, offline save
      return msnOffline.garbageTable(
        this.$route.name,
        this.year,
        this.operationType
      )
    },
  },
  methods: {
    prepareRow(model) {
      if (model && model.amount) {
        if (!isNaN(model.amount)) {
          model.amount = (+model.amount).toFixed(3)
        }
      }
      return model
    },
    afterValidate(ctx, model, errors, els) {
      let { tr } = els
      if (errors.danger) {
        delete errors.danger
        errors.fkkoName = 'Выберите отход'
      }
      if (errors.code) {
        delete errors.code
        errors.fkkoName = 'Выберите отход'
      }

      try {
        if (model.amount >= 1000000000000) {
          errors.amount = 'Значение не должно превышать 999 999 999 999'
          model.amount = 1000000000000
        }
      } catch (e) {
        errors.amount = 'Значение не должно превышать 999 999 999 999'
      }

      if (errors.fkkoName) {
        if (tr) {
          // TODO: not fund focus fields, need queryselector iterator
          try {
            tr.querySelector('[name="fkkoName"]').focus()
          } catch (e) {
            console.error(e)
          }
        }
      }

      return errors
    },
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].fkko) {
          data.data[i].fkkoName = data.data[i].fkko.name

          if (!data.data[i].code) {
            data.data[i].code = data.data[i].fkko.code
          }
          if (!data.data[i].composition) {
            data.data[i].composition = data.data[i].fkko.composition
          }
        } else {
          data.data[i].fkkoName = ''
        }
      }
      return data
    },
    onSelect(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.fkkoName = copy.fkkoName
        model.composition = copy.composition
        model.fkko = { name: copy.fkkoName }
        model.danger = copy.danger
      } else {
        model.code = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.composition = ''
        model.fkko = { name: '' }
        model.danger = ''
      }
    },
    suggestionEndpoint(ctx, q) {
      return cadastr.fkko({ query: { q: q, 'per-page': 50 } })
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger,
        })
      }
      return options
    },
    garbagePostUrl() {
      return msn.garbageOperationPost(this.id, this.operationType)
    },
    garbagePatchUrl(context, model) {
      return msn.garbageOperationPatch(this.id, this.operationType, model.id)
    },
    garbageDeleteUrl(context, model) {
      return msn.garbageOperationDelete(this.id, this.operationType, model.id)
    },
    addNewRowToGarbageTable() {
      const Model = () => {
        const fields = {
          code: '',
          fkko_id: '',
          danger: '',
          amount: '',
          composition: '',
        }
        if (this.hasMsnGarbageYear) {
          fields.year = JSON.parse(JSON.stringify(this.year))
        }
        return fields
      }

      if (this.operationType === 'operation-detail') {
        this.$refs.detail.createRow(new Model())
      } else if (this.operationType === 'operation-detail-separate') {
        this.$refs.detailSeparate.createRow(new Model())
      }
    },
  },
}
</script>
